<template>
  <div class="plan-compare-area">
    <h4 class="tit-h4 mb-7">{{ t('subscription_compare') }}</h4>
    <ul class="plan-sticky">
      <li></li>
      <li>
        <div class="sticky-tit">
          <strong class="tit-h4">Free</strong>
          <span>{{ t('subscription_experience') }}</span>
        </div>
        <button
          type="button"
          class="xl-btn"
          :class="{ 'gray-btn': !isChangePlan('FREE'), 'btn-primary': isChangePlan('FREE') }"
          :disabled="getPlanDisabledState('FREE')"
          @click="handlePlanClick('FREE')"
        >
          {{ getPlanButtonText('FREE') }}
        </button>
      </li>

      <li>
        <div class="sticky-tit">
          <strong class="tit-h4">Starter</strong>
          <span>{{ t('subscription_light_experience') }}</span>
        </div>
        <button
          type="button"
          class="xl-btn"
          :class="{ 'gray-btn': !isChangePlan('STARTER'), 'btn-primary': isChangePlan('STARTER') }"
          :disabled="getPlanDisabledState('STARTER')"
          @click="handlePlanClick('STARTER')"
        >
          {{ getPlanButtonText('STARTER') }}
        </button>
      </li>

      <li>
        <div class="sticky-tit">
          <strong class="tit-h4">Pro</strong>
          <span>{{ t('subscription_continuous_interpretation') }}</span>
        </div>
        <button
          type="button"
          class="xl-btn"
          :class="{ 'gray-btn': !isChangePlan('PRO'), 'btn-primary': isChangePlan('PRO') }"
          :disabled="getPlanDisabledState('PRO')"
          @click="handlePlanClick('PRO')"
        >
          {{ getPlanButtonText('PRO') }}
        </button>
      </li>

      <li>
        <div class="sticky-tit">
          <strong class="tit-h4">Enterprise</strong>
          <span>{{ t('perfect_service_support') }} {{ t('contact_us_freely') }}</span>
        </div>
        <button type="button" class="xl-btn gray-btn" @click="handlePlanClick('ENTERPRISE')">
          {{ getPlanButtonText('ENTERPRISE') }}
        </button>
      </li>
    </ul>

    <div class="comparea-tb-wrap">
      <div class="table">
        <strong class="tit-h5">{{ t('usage_amount_and_credit') }}</strong>
        <div class="row first">
          <div class="row-td first">
            <span>{{ t('monthly_fee') }}</span>
          </div>
          <div class="row-td">
            <span>{{ t('ss_price_free') }}</span>
          </div>
          <div class="row-td">
            <span>
              {{
                formatCurrency(
                  planPrices['STARTER']?.[subscriptionStore.currency].pricePerMonth,
                  subscriptionStore.currency
                )
              }}
            </span>
          </div>
          <div class="row-td">
            <span>
              {{
                formatCurrency(
                  planPrices['PRO']?.[subscriptionStore.currency].pricePerMonth,
                  subscriptionStore.currency
                )
              }}
            </span>
          </div>
          <div class="row-td">
            <span>{{ t('inquiry') }}</span>
          </div>
        </div>
        <div class="row">
          <div class="row-td first">
            <span>{{ t('credit') }}</span>
          </div>
          <div class="row-td">
            <span>1,000 {{ t('credit') }}</span>
          </div>
          <div class="row-td">
            <span>{{ formatNumberWithComma(planPrices['STARTER']?.KRW.creditIncluded) }} {{ t('credit') }}</span>
          </div>
          <div class="row-td">
            <span>{{ formatNumberWithComma(planPrices['PRO']?.KRW.creditIncluded) }} {{ t('credit') }}</span>
          </div>
          <div class="row-td">
            <span>{{ t('inquiry') }}</span>
          </div>
        </div>

        <div class="row">
          <div class="row-td first">
            <span>{{ t('credit_purchase_discount_rate') }}</span>
          </div>
          <div class="row-td">
            <span>{{ t('label_none') }}</span>
          </div>
          <div class="row-td">
            <span>25%</span>
          </div>
          <div class="row-td">
            <span>50%</span>
          </div>
          <div class="row-td">
            <span>{{ t('inquiry') }}</span>
          </div>
        </div>
      </div>

      <div class="table">
        <strong class="tit-h5">{{ t('label_interpretation') }}</strong>

        <div class="row first">
          <div class="row-td first">
            <span>{{ t('ss_small_conversation') }}</span>
          </div>
          <div class="row-td">
            <span>~32{{ t('label_minute') }}</span>
          </div>
          <div class="row-td">
            <span>~8{{ t('label_hour') }}</span>
          </div>
          <div class="row-td">
            <span>~46{{ t('label_hour') }}</span>
          </div>
          <div class="row-td">
            <span>{{ t('inquiry') }}</span>
          </div>
        </div>

        <div class="row">
          <div class="row-td first">
            <span>{{ t('label_conference') }}</span>
          </div>
          <div class="row-td">
            <span>~9{{ t('label_minute') }}</span>
          </div>
          <div class="row-td">
            <span>~2{{ t('label_hour') }} 7{{ t('label_minute') }}</span>
          </div>
          <div class="row-td">
            <span>~12{{ t('label_hour') }} 16{{ t('label_minute') }}</span>
          </div>
          <div class="row-td">
            <span>{{ t('inquiry') }}</span>
          </div>
        </div>

        <div class="row">
          <div class="row-td first">
            <span>{{ t('ss_label_convention') }}</span>
          </div>
          <div class="row-td">
            <span>~14{{ t('label_minute') }}</span>
          </div>
          <div class="row-td">
            <span>~3{{ t('label_hour') }} 34{{ t('label_minute') }}</span>
          </div>
          <div class="row-td">
            <span>~20{{ t('label_hour') }} 41{{ t('label_minute') }}</span>
          </div>
          <div class="row-td">
            <span>{{ t('inquiry') }}</span>
          </div>
        </div>
      </div>

      <div class="table">
        <strong class="tit-h5">{{ t('additional_features') }}</strong>

        <div class="row first">
          <div class="row-td first">
            <span>{{ t('ss_simultaneous_session') }}</span>
          </div>
          <div class="row-td">
            <CloseIcon class="n-icon" />
          </div>
          <div class="row-td">
            <IconCheck class="y-icon" />
          </div>
          <div class="row-td">
            <IconCheck class="y-icon" />
          </div>
          <div class="row-td">
            <IconCheck class="y-icon" />
          </div>
        </div>

        <div class="row">
          <div class="row-td first">
            <span>{{ t('auto_add_support') }}</span>
          </div>
          <div class="row-td">
            <CloseIcon class="n-icon" />
          </div>
          <div class="row-td">
            <CloseIcon class="n-icon" />
          </div>
          <div class="row-td">
            <IconCheck class="y-icon" />
          </div>
          <div class="row-td">
            <IconCheck class="y-icon" />
          </div>
        </div>
      </div>

      <div class="table">
        <strong class="tit-h5">{{ t('custom_support') }}</strong>
        <div class="row first">
          <div class="row-td first">
            <span>{{ t('full_service_support') }}</span>
          </div>
          <div class="row-td">
            <CloseIcon class="n-icon" />
          </div>
          <div class="row-td">
            <CloseIcon class="n-icon" />
          </div>
          <div class="row-td">
            <CloseIcon class="n-icon" />
          </div>
          <div class="row-td">
            <IconCheck class="y-icon" />
          </div>
        </div>

        <div class="row">
          <div class="row-td first">
            <span>{{ t('multi_channel_service_support') }}</span>
          </div>
          <div class="row-td">
            <CloseIcon class="n-icon" />
          </div>
          <div class="row-td">
            <CloseIcon class="n-icon" />
          </div>
          <div class="row-td">
            <CloseIcon class="n-icon" />
          </div>
          <div class="row-td">
            <IconCheck class="y-icon" />
          </div>
        </div>

        <div class="row">
          <div class="row-td first">
            <span>{{ t('enterprise_consulting_support') }}</span>
          </div>
          <div class="row-td">
            <CloseIcon class="n-icon" />
          </div>
          <div class="row-td">
            <CloseIcon class="n-icon" />
          </div>
          <div class="row-td">
            <CloseIcon class="n-icon" />
          </div>
          <div class="row-td">
            <IconCheck class="y-icon" />
          </div>
        </div>

        <div class="row">
          <div class="row-td first">
            <span>{{ t('interpretation_operation_support') }}</span>
          </div>
          <div class="row-td">
            <CloseIcon class="n-icon" />
          </div>
          <div class="row-td">
            <CloseIcon class="n-icon" />
          </div>
          <div class="row-td">
            <CloseIcon class="n-icon" />
          </div>
          <div class="row-td">
            <IconCheck class="y-icon" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconCheck from '@/components/icons/IconCheck.vue';
import CloseIcon from '@/components/icons/IconClose.vue';
import { useModalSurvey } from '@/composables/domains/self-service/useModalSurvey';
import { useGtag } from '@/composables/shared/useGtag';
import { usePayment } from '@/composables/shared/usePayment';
import { usePlan } from '@/composables/shared/usePlan';
import { useSubscriptionStore } from '@/stores/subscription';
import { PlanPricing } from '@/types/components';
import { formatNumberWithComma } from '@/utils/stringUtils.js';

withDefaults(
  defineProps<{
    planPrices?: Record<string, PlanPricing>;
  }>(),
  {
    planPrices: () => ({}),
  }
);

const { t } = useI18n();
const router = useRouter();

const subscriptionStore = useSubscriptionStore();

const { formatCurrency, getPlanDisabledState, getPlanButtonText } = usePlan();
const {
  hasRegisteredCard,
  openCardRegisterPopup,
  openCardManagePopup,
  openSubscriptionPaymentPopup,
  openResubscriptionPopup,
} = usePayment();
const { setTypeSurveyUnsubscribe, openModalSurvey } = useModalSurvey();
const { trackEventFunnel } = useGtag();

const isLoading = ref<boolean>(false);

const isChangePlan = (plan): boolean => {
  if (['FREE', 'ENTERPRISE'].includes(plan)) {
    return false;
  }

  return plan !== subscriptionStore.currentPlan && subscriptionStore.currentPlanStatus !== 'PLANNED';
};

const handlePlanClick = async (plan) => {
  if (isLoading.value) return;

  try {
    isLoading.value = true;
    trackEventFunnel('click_plan_compare_button', {
      plan,
      billingCycle: subscriptionStore.currentPlanDetails?.billingCycle,
    });

    if (plan === 'ENTERPRISE') {
      goToContactPage();
      return;
    }

    if (plan === 'FREE' && ['STARTER', 'PRO'].includes(subscriptionStore.currentPlan)) {
      openUnSubscriptionPopup();
      return;
    }

    if (plan === subscriptionStore.currentPlan && subscriptionStore.currentPlanStatus === 'CANCEL') {
      openResubscriptionPopup(subscriptionStore.currentPlanDetails?.billingCycle);
      return;
    }

    if (!hasRegisteredCard()) {
      const registeredCardType = await openCardRegisterPopup();
      if (!registeredCardType) {
        return;
      }
    }

    const selectedCardType = await openCardManagePopup('PAYMENT', subscriptionStore.paymentType);
    if (!selectedCardType) {
      return;
    }

    openSubscriptionPaymentPopup(plan, subscriptionStore.currentPlanDetails?.billingCycle);
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const goToContactPage = () => {
  trackEventFunnel('redirect_contact_page');

  router.push({ name: 'ss-contact' });
};

const openUnSubscriptionPopup = () => {
  trackEventFunnel('open_unsubscription_popup');

  setTypeSurveyUnsubscribe();
  openModalSurvey();
};
</script>

<style scoped lang="scss">
.plan-compare-area {
  padding-top: 128px;
  .tit-h4 {
    text-align: center;
  }
  .plan-sticky {
    display: flex;
    position: sticky;
    top: 65px;
    background: #fff;
    padding: 2rem 0;
    gap: 1rem;
    li {
      flex: 1 1 0%;
      .sticky-tit {
        min-height: 100px;
        strong {
          display: block;
          text-align: left;
          padding-bottom: $size-s;
        }
        span {
          font-size: $font-size-psmall;
        }
      }
    }
  }
}

.comparea-tb-wrap {
  .table {
    > strong {
      display: block;
      padding: 1rem 0;
    }
    margin-bottom: 56px;
    &:last-child {
      margin-bottom: 0;
    }
    .row {
      &.first {
        border-top: 1px solid $color-gray-40;
      }
      display: flex;
      border-bottom: 1px solid $color-gray-40;
      padding: 1rem 0.75rem;
      .row-td {
        flex: 1 1 0%;
        text-align: center;
        &.first {
          text-align: left;
        }
        svg {
          width: 20px;
          height: 20px;
          object-fit: contain;
          &.n-icon {
            color: $color-gray-200;
          }
          &.y-icon {
            color: $color-navy-100;
            :deep(path) {
              stroke-width: 1px !important;
            }
          }
        }
      }
    }
  }
}
</style>
